import React from 'react'

function Footer() {
  return (
    <footer class="text-cusWhite bg-cusBlue body-font">
        
  <div class="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">
  <a href='https://muaazkhan.netlify.app'  class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">

<span class="ml-3 text-3xl">MK.</span>
</a>
    
    <p class="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">© 2021 Muaaz Khan —
      <a href="https://www.instagram.com/maazy._.k/" class="text-gray-600 ml-1" rel="noopener noreferrer" target="_blank">@maazy._.k</a>
    </p>
    <span class="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
    

      <a class="ml-3 text-gray-500" href='https://www.linkedin.com/in/muaaz-khan-a8731b232/' >
      <svg fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0" class="w-5 h-5" viewBox="0 0 24 24">
          <path stroke="none" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
          <circle cx="4" cy="4" r="2" stroke="none"></circle>
        </svg>
      </a>
   
    </span>
  </div>
</footer>
  )
}

export default Footer